import Vue from 'vue';
import Vuex from 'vuex';
import * as lang from './lang.js';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      currentLocale: 'en',
      texts: null,
    },
    mutations: {
        changeLocale (state, payload) {
            if (!lang.ALL_LOCALES.includes(payload)) {
                console.log('No such locale found');

                return;
            }

            state.currentLocale = payload;
            document.documentElement.setAttribute('lang', payload);
        },
        setTexts (state, payload) {
            state.texts = payload;
        },
    },
    getters: {
        getText: (state) => (key) => {
            const currentLocale = state.currentLocale;
            return (state.texts && state.texts[key] && state.texts[key][currentLocale])
                ? state.texts[key][currentLocale]
                : '';
        },
        getCurrentLocale: (state) => {
            return state.currentLocale;
        },
        getRouteUrl: (state) => (route) => {
            return state.currentLocale === lang.LV ? `/${route}` : `/${state.currentLocale}/${route}`;
        },
    }
  })